(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('BillingController', BillingController);

	BillingController.$inject = ['userPouch', '$log', 'lodash', 'API', 'ENV'];

	function BillingController(userPouch, $log, lodash, API, ENV) {

		/* jshint validthis: true */
		var self = this;

        self.stripeKey = ENV.STRIPE_KEY;

        self.state = {
            success: false,
            message: '',
            sending: false,
			defaultCardErr: null,
			defaultCard: null
        };

        self.params = {
        	name: null,
			key: null,
        	stripeToken: null
		};

        self.activeUser = null;

		self.submit = submit;
		self.setToken = setToken;

		initialize();

		function initialize(){

			userPouch.getActiveUser().then(function(user){
				self.params.name = lodash.get(user, 'name');
				self.params.email = lodash.get(user, 'metadata.email');
				self.params.key = lodash.get(user, 'derived_key');

                API.cardDetails(self.params.name, self.params.key).then(function(response) {
                    $log.debug('API card details response', response);
                    self.state.defaultCard = response.data.card;
                }).catch(function(response){
                    $log.error(response);
                    self.state.defaultCardErr = response.data.error;
                });

			});
		}

		/** begin methods */

		function submit(){

            self.state.sending = true;

            API.updateCreditCard(self.params.name, self.params.key, self.params.stripeToken).then(function(response) {

                $log.debug('API updated card response', response);

                self.state.success = true;
                self.state.message = response.message;

            }).catch(function(response){

                $log.error(response);

                self.state.message = response.data.error;

            }).finally(function(){

                self.state.sending = false;

            });

		}

        function setToken(token){
            self.params.stripeToken = token.id;
        }
	}

})();
